import { useCallback, useRef } from 'react';
import { EffectCoverflow } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useStore } from '@@/store';
import styles from './style.module.scss';

const CharacterDetail = ({
  initialIndex,
  onClose,
}) => {
  const swiperRef = useRef();
  const { store: { sounds: [soundsAction, soundsStatus] } } = useStore();

  const handleClose = () => {
    onClose();
  };

  const onSwiper = useCallback((swiper) => {
    swiperRef.current = swiper;
  }, []);

  const playVoice = (index) => {
    const key = `voice${index}`;
    const isPlaying = soundsStatus[key];
    if (isPlaying) {
      soundsAction.pause(key, 'stop');
    } else {
      soundsAction.play(key);
    }
  };

  const onClickChangeSlide = (direction) => {
    const { current: swiper } = swiperRef;
    if (direction === 'prev') {
      swiper.slidePrev();
    } else {
      swiper.slideNext();
    }
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.closeBtn}
        onClick={handleClose}
      >
        <span /><span />
      </div>
      <div className={styles.prev} onClick={() => { onClickChangeSlide('prev'); }} />
      <div className={styles.next} onClick={() => { onClickChangeSlide('next'); }} />
      <Swiper
        className={styles.swiper}
        modules={[EffectCoverflow]}
        slidesPerView={1}
        loopAdditionalSlides={2}
        onSwiper={onSwiper}
        initialSlide={initialIndex}
        effect="coverflow"
        grabCursor
        centeredSlides
        coverflowEffect={{
          rotate: 5,
          stretch: '60%',
          depth: 200,
          modifier: 1,
          slideShadows: false,
        }}
        loop
      >
        {new Array(4).fill('').map((_, index) => (
          <SwiperSlide key={index}>
            <div
              className={`${styles.characterItem} ${styles[`item${index + 1}`]}`}
            >
              <div className={styles.voiceBtn1} onClick={() => playVoice(`${index + 1}_${1}`)} />
              <div className={styles.voiceBtn2} onClick={() => playVoice(`${index + 1}_${2}`)} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CharacterDetail;
